"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useModal_1 = require("hooks/useModal");
const ClassServiceUtil_1 = __importDefault(require("modules/classManager/ClassServiceUtil"));
const useTransferOfferAlert = ({ onAlertConfirm }) => {
    const [isTransfeOfferAlertEnable, setIsTransferOfferAlertEnable] = (0, react_1.useState)(false);
    const [selectedTransferOffersIds, setSelectedTransferOfferIds] = (0, react_1.useState)([]);
    const { isModalOpen: isAlertOpen, handleClose, handleOpen } = (0, useModal_1.useModal)();
    const showTransferOfferAlert = (initialSelectedOffers, newSelectedOfferIds) => {
        const hasNewSelectedOffers = ClassServiceUtil_1.default.hasNewSelectedOffers(newSelectedOfferIds, initialSelectedOffers);
        if (!isTransfeOfferAlertEnable && hasNewSelectedOffers) {
            handleOpen();
            setSelectedTransferOfferIds(newSelectedOfferIds);
            return true;
        }
        return false;
    };
    const handleConfirmAlert = () => {
        onAlertConfirm === null || onAlertConfirm === void 0 ? void 0 : onAlertConfirm(selectedTransferOffersIds);
        setIsTransferOfferAlertEnable(true);
        handleClose();
    };
    const handleCloseAlert = () => {
        handleClose();
    };
    return {
        isAlertOpen,
        showTransferOfferAlert,
        handleConfirmAlert,
        handleCloseAlert
    };
};
exports.default = useTransferOfferAlert;
